var map = {
	"./apple-laurel-da-DK.svg": 62197,
	"./apple-laurel-de-DE.svg": 90159,
	"./apple-laurel-en-GB.svg": 92157,
	"./apple-laurel-en-US.svg": 61490,
	"./apple-laurel-es-ES.svg": 67953,
	"./apple-laurel-es-MX.svg": 77426,
	"./apple-laurel-fr-FR.svg": 9877,
	"./apple-laurel-it-IT.svg": 83583,
	"./apple-laurel-nb-NO.svg": 51848,
	"./apple-laurel-nl-NL.svg": 51597,
	"./apple-laurel-pl-PL.svg": 57361,
	"./apple-laurel-pt-BR.svg": 22865,
	"./apple-laurel-pt-PT.svg": 62689,
	"./apple-laurel-sv-SE.svg": 82708
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87083;